import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCzFIuUuaBaiMDMcx9ivqptdEa2cuqQQ1U',
  authDomain: 'react-auth-4b304.firebaseapp.com',
  projectId: 'react-auth-4b304',
  storageBucket: 'react-auth-4b304.appspot.com',
  messagingSenderId: '757197872520',
  appId: '1:757197872520:web:6f34148506d942ec8dae3d',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const authentication = getAuth(app);
